/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizeropenpage2Inputs */

const en_organizeropenpage2 = /** @type {(inputs: Organizeropenpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View page`)
};

const de_organizeropenpage2 = /** @type {(inputs: Organizeropenpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seite ansehen`)
};

/**
* | output |
* | --- |
* | "View page" |
*
* @param {Organizeropenpage2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizeropenpage2 = /** @type {((inputs?: Organizeropenpage2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizeropenpage2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizeropenpage2(inputs)
	return de_organizeropenpage2(inputs)
});
export { organizeropenpage2 as "organizerOpenPage" }